// extracted by mini-css-extract-plugin
export var avatar = "styles-module--avatar--t-Yr-";
export var details = "styles-module--details--dMwlx";
export var disclaimer = "styles-module--disclaimer--gSkBd";
export var divider = "styles-module--divider--CPUMr";
export var header = "styles-module--header--aIkeF";
export var jobTitle = "styles-module--job-title---Lmb3";
export var name = "styles-module--name--tMN5B";
export var personInfo = "styles-module--person-info--MBSeM";
export var quote = "styles-module--quote--nOevm";
export var root = "styles-module--root--MQY-O";